import React, { useState, useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { Comment } from '@ant-design/compatible'
import { UserOutlined } from '@ant-design/icons'
import { Avatar, Form, Input, message } from 'antd'
import Button from 'components/shared/button'
import { CreateCommentDocument } from 'graphql/generated/types'

const { TextArea } = Input
export default function RenderComment({
  item,
  parent,
  level = 0,
  id,
  setmodalVisible,
  setComments,
  status,
  style,
  related,
}) {
  const [toggle, setToggle] = useState(false)
  const [currId, setCurrId] = useState(null)
  const [currentUserToken, setCurrentUserToken] = useState(null)
  const [form] = Form.useForm()
  const margin = `${5 * level}rem`
  const [AddComment] = useMutation(CreateCommentDocument, {
    context: {
      headers: {
        Authorization: `Bearer ${currentUserToken}`,
      },
    },
  })

  useEffect(() => {
    if (localStorage?.authToken) {
      setCurrentUserToken(localStorage.authToken)
    }
  }, [])
  //  handling state on appending children comment
  const hadleCommentUpdate = (updatedComment, Id = null) => {
    // eslint-disable-next-line
    const childComments = Id
      ? parent.children.map((comment) =>
          comment.id === Id ? updatedComment : comment
        )
      : parent.children
      ? [updatedComment, ...parent.children]
      : [updatedComment]
    const updatedParent = {
      ...parent,
      children: childComments,
    }
    setComments(updatedParent, parent.id)
  }

  const handleReply = (e) => {
    setToggle(!toggle)
    setCurrId(e.id)
  }
  const submitComment = (content) => {
    AddComment({
      variables: {
        input: {
          content,
          relation: `${related}:${id}`,
          threadOf: currId,
          author: {
            id: localStorage.getItem('userId'),
            name: localStorage.getItem('userEmail').split('@')[0],
            email: localStorage.getItem('userEmail'),
            avatar: localStorage.getItem('profileUrl'),
          },
        },
      },
    })
      .then((response) => {
        form.resetFields()
        hadleCommentUpdate(response.data.createComment)
        setToggle(false)
        setmodalVisible(false)
      })
      .catch((err) => {
        if (err.status === 403) {
          localStorage.setItem('message', content.comment)
          message.info('Please login again to continue..')
          setmodalVisible(true)
        } else {
          message.error('Sorry Something Went Wrong!')
        }
      })
  }

  const handleAddComment = (values) => {
    if (currentUserToken) {
      // Submiting Comment
      submitComment(values.comment)
    } else {
      localStorage.setItem('message', values.comment)
      localStorage.setItem('parentId', currId)
      setmodalVisible(true)
    }
  }

  return (
    <>
      <Comment
        actions={
          level < 3 && [
            status === 'APPROVED' && (
              <Button
                type="link"
                block
                key={item.id}
                id={item.id}
                onClick={() => handleReply(item)}
                source="comment-reply"
              >
                Reply to
              </Button>
            ),
            // <span key={item.id} id={item.id} onClick={() => handleReply(item)}>
            //   Reply to
            // </span>,
          ]
        }
        content={
          <p id={item.id} style={style}>
            {item.content}
          </p>
        }
        author={<h3>{item?.author?.name}</h3>}
        avatar={
          item.author.avatar ? (
            <Avatar src={item.author.avatar} />
          ) : (
            <Avatar size={55} icon={<UserOutlined />} />
          )
        }
        // datetime={dateformat(item.createdAt, 'dddd, mmmm dS, yyyy, h:MM TT')}
        style={{ marginLeft: margin }}
        key={item.id}
      />
      {toggle && (
        <Form
          form={form}
          name="basic"
          style={{ marginLeft: `${5 * level}rem` }}
          onFinish={(e) => handleAddComment(e)}
        >
          <Form.Item
            name="comment"
            rules={[
              {
                required: true,
                message: 'Please type Comment to continue...',
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" source="add-comment">
              Submit
            </Button>
          </Form.Item>
        </Form>
      )}
      {item.children?.map((itemChild) => {
        return (
          ['APPROVED', 'PENDING'].includes(itemChild.approvalStatus) && (
            <RenderComment
              style={
                itemChild.approvalStatus === 'PENDING'
                  ? { color: '#CAC7CE' }
                  : { color: '' }
              }
              parent={itemChild}
              key={itemChild.id}
              item={itemChild}
              level={level + 1}
              id={id}
              setmodalVisible={setmodalVisible}
              setComments={hadleCommentUpdate}
              status={itemChild.approvalStatus}
              related={related}
            />
          )
        )
      })}
    </>
  )
}
